type isDisabled = {
    isDisabled: boolean
}

export const selectStyles = {
    control: (baseStyles: object) => ({
        ...baseStyles,
        backgroundColor: "#212529",
        border: "none",
    }),
    menu: (baseStyles: object) => ({
        ...baseStyles,
        backgroundColor: "#212529",
        color: "#fff"
    }),
    option: (baseStyles: object) => ({
        ...baseStyles,
        backgroundColor: "#212529",
        ":hover": {
            backgroundColor: "rgb(51, 51, 51)"
        },
        ":active": {
            backgroundColor: "rgb(51, 51, 51)",
            color: "#fff"
        }
    }),
    multiValue: (baseStyles: object) => ({
        ...baseStyles,
        backgroundColor: "rgb(51, 51, 51)",
        color: "#fff"
    }),
    singleValue: (baseStyles: object) => ({
        ...baseStyles,
        color: "#fff"
    }),
    multiValueLabel: (baseStyles: object) => ({
        ...baseStyles,
        backgroundColor: "rgb(51, 51, 51)",
        color: "#fff"
    }),
    multiValueRemove: (baseStyles: object) => ({
        ...baseStyles,
        ":hover": {
            backgroundColor: "rgb(69, 75, 81)"
        },
    }),
    input: (baseStyles: object) => ({
        ...baseStyles,
        color: "#fff"
    }),
};

export const genreSelectStyles: any = {
    ...selectStyles,
    control: (baseStyles: object,  {isDisabled}: isDisabled) => ({
        ...baseStyles,
        backgroundColor: isDisabled ?  "#343a40" : "#212529",
        width: "100%",
        marginLeft: "0",
        float: "left",
        border: "1px solid #495057",
        marginTop: "2px"
    }),
    menu: (baseStyles: object) => ({
        ...baseStyles,
        backgroundColor: "#212529",
        color: "#fff",
        position: "absolute",
        top: "33px",
        width: "100%",
    }),
    menuList: (baseStyles: object) => ({
        ...baseStyles,
        height: "250px"
    })
}

const airDaySeasonSelectStyles = {
    ...selectStyles,
    control: (baseStyles: object,  {isDisabled}: isDisabled) => ({
        ...baseStyles,
        backgroundColor: isDisabled ?  "#343a40" : "#212529",
        width: "100%",
        marginLeft: "0",
        float: "left",
        border: "1px solid #495057",
        marginTop: "2px"
    }),
    menu: (baseStyles: object) => ({
        ...baseStyles,
        backgroundColor: "#212529",
        color: "#fff",
        position: "absolute",
        top: "33px",
        width: "100%",
    }),
    menuList: (baseStyles: object) => ({
        ...baseStyles,
        height: "150px"
    })
}

export const airDaySelectStyles: any = {
    ...airDaySeasonSelectStyles,
    menuList: (baseStyles: object) => ({
        ...baseStyles,
        height: "215px"
    })
}

export const seasonSelectStyles: any  = {
    ...airDaySeasonSelectStyles,
    menuList: (baseStyles: object) => ({
        ...baseStyles,
        height: "170px"
    })
}

export const typeOptions = [
    { value: "tv", label: "TV"},
    { value: "movie", label: "Movie"},
    { value: "ova", label: "OVA"},
    { value: "ona", label: "ONA"},
    { value: "special", label: "Special"},
];

export const sourceOptions = [
    { value: "original", label: "Original" },
    { value: "manga", label: "Manga" },
    { value: "manwha", label: "Manwha" },
    { value: "web manga", label: "Web manga" },
    { value: "4-koma manga", label: "4-koma manga" },
    { value: "novel", label: "Novel" },
    { value: "light novel", label: "Light Novel" },
    { value: "visual novel", label: "Visual Novel" },
    { value: "game", label: "Game" },
    { value: "card game", label: "Card game" },
    { value: "music", label: "Music" },
    { value: "book", label: "Book" },
    { value: "picture book", label: "Picture book" },
    { value: "other", label: "Other" },
    { value: "unknown", label: "Unknown" },
    { value: "miscellaneous", label: "Miscellaneous" },
];

export const airStatusOptions = [
    {value: "To be aired", label: "To be aired"},
    {value: "Airing", label: "Airing"},
    {value: "Finished airing", label: "Finished airing"},
];

export const airDayOptions = [
    {value: "", label: "-"},
    {value: "Monday", label: "Monday"},
    {value: "Tuesday", label: "Tuesday"},
    {value: "Wednesday", label: "Wednesday"},
    {value: "Thursday", label: "Thursday"},
    {value: "Friday", label: "Friday"},
    {value: "Saturday", label: "Saturday"},
    {value: "Sunday", label: "Sunday"},
]

export const yearNameOptions = [
    {value: null, label: "-"},
    {value: "winter", label: "Winter"},
    {value: "spring", label: "Spring"},
    {value: "summer", label: "Summer"},
    {value: "fall", label: "Fall"}
]